import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { Page } from "src/app/model/Page";
import { SchemeModel } from "src/app/model/SchemeModel";
import { MasterService } from "src/app/services/master.service";

@Component({
  selector: "app-secure-scheme-list",
  templateUrl: "./scheme-list.component.html",
  styleUrls: ["./scheme-list.component.scss"],
})
export class SchemeListComponent implements OnInit {
  page: Page<SchemeModel>;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  nonEditable: boolean;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<SchemeModel> = new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "scheme",
    "incomeGroup",
    "lottery",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  constructor(
    private router: Router,
    private masterService: MasterService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
      ]),
    });

    this.onLoad();
  }

  resetFilter() {
    this.filterForm.controls["filterText"].setValue(null);
    this.onLoad();
  }

  onLoad() {
    this.isLoading = true;
    this.masterService
      .fetchSchemeList(
        this.currentPage,
        this.pageSize,
        this.filterForm.value.filterText
      )
      .subscribe(
        (data) => {
          this.isLoading = false;
          this.isSearchDisabled = false;
          if (data.status === "SUCCESS") {
            this.page = data.page;
            this.dataSource = new MatTableDataSource(this.page.content);
            this.nonEditable = data.nonEditable;
            setTimeout(() => {
              this.paginator.pageIndex = this.currentPage;
              this.paginator.length = this.page.totalElements;
            });
          } else {
            this.nonEditable = true;
            this.masterService.errorToast(data.errorMessage);
          }
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
          this.isSearchDisabled = false;
        }
      );
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.onLoad();
    } else {
      this._snackBar.open(
        "Please enter Filter text (minimum - 3 char) for Scheme",
        "Close",
        {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        }
      );
      this.isSearchDisabled = false;
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onLoad();
  }

  edit(key: number) {
    this.router.navigate(["/secure", "master", "scheme", "au", key]);
  }
}
